module.exports = __webpack_public_path__ + "static/orange-bicycle_2008-3f5453e7bdc2117b5e5ee49ad27f0ac3.jpg";